import React from 'react';
import { UtilityText } from '@leagueplatform/genesis-core';
import { TableRow } from '../table-row/table-row.component';

export interface TableEmptyStateProps {
  /** Number of columns to span */
  colSpan: number;
  /** Message to display when table is empty */
  message: string;
  /** Additional CSS styles for the text */
  css?: React.ComponentProps<typeof UtilityText>['css'];
}

/**
 * Shared empty state component for tables.
 * Renders an empty message within a table row that spans all columns.
 */
export const TableEmptyState: React.FC<TableEmptyStateProps> = ({
  colSpan,
  message,
  css,
}) => (
  <TableRow colSpan={colSpan}>
    <UtilityText
      size="sm"
      css={{
        color: '$onSurfaceMuted',
        ...css,
      }}
    >
      {message}
    </UtilityText>
  </TableRow>
);
